module.exports = __webpack_public_path__ + "static/media/ODS12.c3d7424a.jpg";